module.exports = __webpack_public_path__ + "static/media/435910480_1160965741592281_7273643488046599789_n.ae60a336.jpg";